// Reports/Resultados/Report/ResultadosForm.js
import React from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { reduxForm, getFormValues } from "redux-form";
import { connect } from "react-redux";
import ResultadosTable from "./Tables/ResultadosTable/ResultadosTable";

let ResultadosForm = (props) => {
    return (
        <CardEmpty isMarginButtom noShadow>
            <div className="row col-md-12 p-0 mb-4 mt-4">
                <div className="col-md-6">
                    <h4 className="mr-2 titulo_principal">
                        RESULTADOS ANUALES
                    </h4>
                </div>
                <div className="col-md-6 d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                        className="btn btn-light btn-sm justify-content-end agregar-tab-generica"
                        onClick={() => props.openAndConsultModal()}
                    >
                        CONFIGURACIÓN ANUAL
                    </button>
                </div>
            </div>
            <form>
                <ResultadosTable {...props} />
            </form>
        </CardEmpty>
    );
};

const formName = "ResultadosForm";

const mapStateToProps = (state) => {
    return {
        resultados_data: getFormValues("ResultadosForm")(state),
    };
};

export default connect(mapStateToProps)(
    reduxForm({
        form: formName,
    })(ResultadosForm)
);
